import { z } from 'zod';
export const HealthStatusSchema = z.enum(['healthy', 'degraded', 'unhealthy']);
export const HealthResponseSchema = z.object({
    status: HealthStatusSchema,
    service: z.string(),
    version: z.string(),
    environment: z.string(),
    timestamp: z.string(),
    uptimeSeconds: z.number().nonnegative(),
});
export const DatabaseReadinessSchema = z.object({
    connected: z.boolean(),
    latencyMs: z.number().nonnegative().optional(),
});
export const ReadinessResponseSchema = z.object({
    status: z.enum(['ready', 'not_ready']),
    service: z.string(),
    version: z.string(),
    timestamp: z.string(),
    database: DatabaseReadinessSchema,
    system: z.object({
        memoryUsageMb: z.number().nonnegative(),
        uptimeSeconds: z.number().nonnegative(),
    }),
});
//# sourceMappingURL=health.js.map